var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countdown"},[_c('h3',{staticClass:"display-1 mb-1"},[_vm._v(_vm._s(_vm.title))]),_c('flip-countdown',{attrs:{"deadline":_vm.date}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }